import $ from 'jquery';
import get from 'lodash/get';
import removeQueryParam from '../../helpers/remove-query-param';

export default function(){
    const searchDrawers = get(window, 'rcProps.trigger.global.openSearchDrawer', false);
    if (searchDrawers === true || searchDrawers === 'true') {
        $('#tr_top_search_btn').trigger('click');
        removeQueryParam('openSearchDrawer');
    }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/amp-search-drawer.js